module.exports = __webpack_public_path__ + "static/Ishmeet Singh.7686f84d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Ishmeet Singh.jpg
// module id = 1215
// module chunks = 6166952557895